import React from 'react';
import AppRouter from './AppRouter';
import './App.css';

const App: React.FC = () => {
  return <AppRouter />;
};

export default App;
